export function formatTime(ts, tz = "UTC") {
  if (!ts) return "-";
  try {
    const d = new Date(ts);
    return (
      d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", timeZone: tz }) +
      " " +
      d.toLocaleDateString([], { month: "short", day: "numeric", timeZone: tz })
    );
  } catch {
    // Fallback if timezone is invalid
    const d = new Date(ts);
    return (
      d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) +
      " " +
      d.toLocaleDateString([], { month: "short", day: "numeric" })
    );
  }
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
